import { HttpService } from '../https.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LawyersService {

  constructor(private httpService: HttpService) {}

  getLauditorProfessionals(
    filters?: {
      city?: string;
      practiceArea?: string;
      service?: string;
      startDatetime?: string;
      endDatetime?: string;
      accountType?: string;
      // Optional exact-match drill-down (dashboard "Total Logged-in Users" card).
      // When present these are sent as a JSON body — { user_ids, firm_ids } —
      // instead of query params, since the list can be arbitrarily long.
      userIds?: string[];
      firmIds?: string[];
    }
  ): Observable<any> {

    const parts: string[] = [];

    if (filters?.city) {
      parts.push(`city=${encodeURIComponent(filters.city)}`);
    }

    if (filters?.practiceArea) {
      parts.push(`practice_area=${encodeURIComponent(filters.practiceArea)}`);
    }

    if (filters?.service) {
      parts.push(`service=${encodeURIComponent(filters.service)}`);
    }

    if (filters?.startDatetime) {
      parts.push(`start_date=${encodeURIComponent(filters.startDatetime)}`);
    }

    if (filters?.endDatetime) {
      parts.push(`end_date=${encodeURIComponent(filters.endDatetime)}`);
    }

    if (filters?.accountType && filters.accountType !== 'all') {
      parts.push(`account_type=${encodeURIComponent(filters.accountType)}`);
    }

    const query = parts.length ? `?${parts.join('&')}` : '';

    // Same GET verb, same URL and same query string in both cases — an
    // id-based drill-down just additionally carries { user_ids, firm_ids }
    // as the request body.
    const userIds = filters?.userIds ?? [];
    const firmIds = filters?.firmIds ?? [];

    if (userIds.length || firmIds.length) {
      const payload: { user_ids?: string[]; firm_ids?: string[] } = {};
      if (userIds.length) { payload.user_ids = userIds; }
      if (firmIds.length) { payload.firm_ids = firmIds; }

      return this.httpService.sendReGetRequestWithBody(
        `/professional/search/lauditor${query}`,
        payload
      ) as Observable<any>;
    }

    return this.httpService.sendReGetRequestWithBody(
      `/professional/search/lauditor${query}`, {}
    ) as Observable<any>;
  }

  addProfessional(data: any): Observable<any> {
    return this.httpService.sendRePostRequest('/professional/onboard/lexis', data) as Observable<any>;
  }

  editProfessional(uid: string, data: any): Observable<any> {
    return this.httpService.sendRePutRequest(`/professional/${uid}`, data) as Observable<any>;
  }
    
  updateType(uid: string, data: any): Observable<any> {
    return this.httpService.sendRePatchRequest(`/professional/${uid}`, data) as Observable<any>;
  }

  deleteProfessional(uid: string): Observable<any> {
    return this.httpService.sendReDeleteRequest(`/professional/${uid}`) as Observable<any>;
  }

  getProfessionalDetail(uid: string): Observable<any> {
    return this.httpService.sendReGetRequest(`/professional/${uid}`) as Observable<any>;
  }

  getProfessionalPlan(uid: string): Observable<any> {
    return this.httpService.sendReGetRequest(`/admin/professional/${uid}/plan`) as Observable<any>;
  }

  upgradeProfessionalPlan(uid: string, newPlan: string): Observable<any> {
    return this.httpService.sendRePostRequest(
      `/admin/professional/${uid}/plan/upgrade`,
      { new_plan: newPlan }
    ) as Observable<any>;
  }

  downgradeProfessionalPlan(uid: string, newPlan: string, reason: string): Observable<any> {
    return this.httpService.sendRePostRequest(
      `/admin/professional/${uid}/plan/downgrade`,
      { new_plan: newPlan, reason }
    ) as Observable<any>;
  }
}